import {
  base_colorAction,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
`

export const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const caption = css`
  ${font_sm};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextSecondary};
  letter-spacing: 0.06em;
  text-transform: uppercase;
`

export const captionCount = css`
  text-transform: none;
  letter-spacing: normal;
`

export const chevronButton = css`
  &.Button.no-shell {
    box-shadow: none;
    padding: ${spacing(1)};

    path {
      stroke: ${text_colorTextSecondary};
    }
  }
`

const rowsBase = css`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`

export const rows = css`
  ${rowsBase};
`

export const rowsScrollable = css`
  ${rowsBase};
  max-height: ${spacing(50)};
  overflow-y: auto;
`

export const row = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(3)};
  padding: ${spacing(2)} 0;
  color: ${text_colorTextPrimary};
`

export const cardIdentity = css`
  display: flex;
  align-items: center;
  gap: ${spacing(3)};
  min-width: 0;
`

export const cardName = css`
  ${font_md};
  font-family: ${font_family_weight_medium};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const seeAllButton = css`
  &.Button.no-shell {
    box-shadow: none;
    align-self: flex-start;
    padding: ${spacing(1)} 0;
    color: ${base_colorAction};
    ${font_md};
    font-family: ${font_family_weight_medium};
  }
`
